import { CSSObject, CSSPseudos } from 'styled-components';

const increaseSpecificity = (styles: CSSObject, increaseLevels = 2): CSSPseudos =>
  increaseLevels <= 0
    ? styles
    : {
        [new Array(increaseLevels).fill('&').join('')]: {
          ...styles,
        },
      };

export default increaseSpecificity;
